<template>
    <div class="box-container">
        <div id="home-section-tree" class="container-size-fixer">
            <div class="row">
                <div class="section-tree-main-child col-lg-6 col-sm-12">
                    <div id="title">
                        چرا
                        <span style="color: #cc171d">
                        کانادا از ایران
                    </span>
                    </div>
                    <div id="reasons">
                        <ul  v-if="explain">
                            <li  v-for="item in explain.split(',')" :key="item">
                                <img width="17" height="17" class="reasons-img" src="../assets/appIcons/Pics/CanadaAzIran/Icon/brand-positioning.png" alt="brand">
                                <div class="reason-txt-content">&nbsp; {{item}} &nbsp;</div>
                            </li>
                        </ul>
                        <div style="height: 200px;padding: 50px;" v-if="homeLoadingMood">
                            <img style="height: auto;width: 50%" src="../assets/loader/ezgif.com-gif-maker(1).gif" alt="loader">
                        </div>
                    </div>
                </div>
                <div class="section-tree-main-child  col-lg-6 col-sm-12">
                    <div class="player-container" v-if="file">
                        <img v-if="hidePlayIcon" width="70" height="70" id="play-icon-img" src="../assets/appIcons/Icon/Play.png" alt="">
                        <vue3-video-player @play="hidePlayIconRun" @pause="hidePlayIconRun" :src="$store.state.base_urls.webUploads+file"/>
                    </div>
                        <div style="height: 200px;padding: 130px 50px 50px 50px;" v-if="homeLoadingMood">
                            <img style="height: auto;width: 50%" src="../assets/loader/ezgif.com-gif-maker(1).gif" alt="loader">
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

    <script>
    export default {
        name: "HomeSectionTree",
        data(){
            return {
                hidePlayIcon:true
            }
        },
        props:['file','explain','homeLoadingMood'],
        methods:{
            hidePlayIconRun:function () {
                this.hidePlayIcon=!this.hidePlayIcon;
            }
        }
    }
</script>

<style scoped>
    .box-container{
        overflow: hidden;
        padding: 20px 0;
        margin-top: 10px;
        min-height: 520px;
    }
    #play-icon-img{
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 5;
        cursor: pointer!important;
    }

    .reason-txt-content{
        /*display: inline-block;*/
        width: calc(100% - 17px);
        height: auto;
        text-align: justify;
        padding-left: 10px;
        text-indent: -2%;
        padding-right: 10px;
    }

    .reasons-img{
        width: 17px;
        height: 17px;
        /*display: inline;*/
        /*position: absolute;*/
        right: 0px;
        top: 5px;
    }
    #reasons{display: flex;}
    #reasons>ul>li{
        display: flex;

        position: relative;
        margin-top: 20px;
        text-align: right;
        height: auto;
        width: 100%;
        /*display: block;*/
        font-size: 15px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

    }
    #reasons>ul{
        padding: 0;
        list-style-type: none;
    }
    #title{
        font-family: 'IRANSans';
        font-size: 26px;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        font-weight: 600;
    }

    .section-tree-main-child:nth-child(2) > div{
        width: 100%;
    }
    #home-section-tree{
        padding: 50px 0;
        /*padding: 0 135px;*/
        margin: auto;
        background-color: white;
    }

    .section-tree-main-child:nth-child(2){
        padding: 0;
             width: 100%;
             height: 380px;
         }

    .section-tree-main-child{
        position: relative;
        margin: 0;
        padding: 0;
        height: auto!important;
    }


    .player-container{
        float: right;
        width:100%;
        height: 380px;
        background-color: white;
        position: relative;
    }

    @media (max-width: 1300px) {
        #home-section-tree{
            padding: 0 25px;
        }
        #reasons, #title{
            /*padding-right: 25px;*/
            /*padding-left: 25px;*/
        }
        #title{
            font-size: 26px;
        }

    }

</style>